import React from 'react'
import { Text } from '@chakra-ui/react'

const ErrorMessage = ({ isError }: { isError?: boolean }) => {
  return isError ? (
    <Text mt="0.7rem" fontSize="1rem" align="center" color="brand.red" d="flex">
      <svg
        width="14"
        height="14"
        viewBox="0 0 14 14"
        fill="none"
        xmlns="http://www.w3.org/2000/svg">
        <path
          d="M7.00065 13.6666C3.31865 13.6666 0.333984 10.6819 0.333984 6.99992C0.333984 3.31792 3.31865 0.333252 7.00065 0.333252C10.6827 0.333252 13.6673 3.31792 13.6673 6.99992C13.6673 10.6819 10.6827 13.6666 7.00065 13.6666ZM7.00065 12.3333C8.41514 12.3333 9.77169 11.7713 10.7719 10.7712C11.7721 9.77096 12.334 8.41441 12.334 6.99992C12.334 5.58543 11.7721 4.22888 10.7719 3.22868C9.77169 2.22849 8.41514 1.66659 7.00065 1.66659C5.58616 1.66659 4.22961 2.22849 3.22942 3.22868C2.22922 4.22888 1.66732 5.58543 1.66732 6.99992C1.66732 8.41441 2.22922 9.77096 3.22942 10.7712C4.22961 11.7713 5.58616 12.3333 7.00065 12.3333ZM6.33399 3.66658H7.66732V4.99992H6.33399V3.66658ZM6.33399 6.33325H7.66732V10.3333H6.33399V6.33325Z"
          fill="#FD397A"
        />
      </svg>
      <Text as="span" ml="0.5rem">
        {isError}
      </Text>
    </Text>
  ) : null
}

export { ErrorMessage }
